import { useRef, useState } from "react";
import cls from "classnames";
import useScrollHeight from "@qoohoo/common/hooks/useScrollHeight";
import { linkifyText } from "@qoohoo/common/utils/url";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { button } from "@qoohoo/common/constants/analytics";

const Description = ({ text, className, trackDetails }) => {
  const textBodyRef = useRef(null);
  const isVisible = useScrollHeight(textBodyRef);
  const [showMore, setShowMore] = useState(false);

  const textPostContent = getTextPostContent(text);

  function getTextPostContent(text) {
    let returnText = text || "";
    const secureUrlRegex = new RegExp("https://", "g");
    const nonSecureUrlRegex = new RegExp("http://", "g");

    if (returnText) {
      returnText = returnText.replace(secureUrlRegex, "");
      returnText = returnText.replace(nonSecureUrlRegex, "");
    }

    return returnText;
  }

  return textPostContent ? (
    <div className={className}>
      <p
        ref={textBodyRef}
        className={cls(
          "mb-1 max-w-full whitespace-pre-wrap",
          `line-clamp-4 sm:line-clamp-3 dark:text-[#161A1D]`,
          showMore && "!line-clamp-none"
        )}
        dangerouslySetInnerHTML={{
          __html: linkifyText(textPostContent),
        }}
      ></p>
      {isVisible && (
        <button
          className="font-semibold font-inter hover:opacity-90 dark:text-[#161A1D]"
          onClick={() => {
            setShowMore(!showMore);

            Track.buttonClick(button.post_see_more, trackDetails);
          }}
        >
          {showMore ? null : "see more"}
        </button>
      )}
    </div>
  ) : null;
};

export default Description;
